import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import $ from 'jquery';
import M from 'materialize-css/dist/js/materialize';
import VolumeItem from '../VolumeItem/VolumeItem';
import VolumeItemList from '../VolumeItem/VolumeItemList';
import ConfirmationVolume from '../ConfirmationVolume';
import VolumeParameters from '../VolumeParameters';
import VolumeRegistrarion from '../VolumeRegistration/VolumeRegistration';
import VolumeRegistrationList from '../VolumeRegistration/VolumeRegistrationList';

const Volume = (props) => {
  const [table, setTable] = useState(0);
  const [refresh, setRefresh] = useState(0);

  const getTabName = (tabIndex) => {
    switch (tabIndex) {
      case 0:
        return 'startVolume';
      case 1:
        return 'registrationVolume';
      case 2:
        return 'confirmVolume';
      case 3:
        return 'volumeParameters';
      default:
        return 'startVolume';
    }
  }

  useEffect(() => {
    const el = $('.tabs');
    M.Tabs.init(el);
    M.Tabs.getInstance(el).select(table);
    onSelectedTabToProps(props.location?.state?.table, props.location?.state?.refresh);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    onSelectedTabRefresh();
    // eslint-disable-next-line
  }, [refresh]);

  const onSelectedTabRefresh = () => {
    if (refresh > 0) {
      const el = $('.tabs');
      const dados = M.Tabs.getInstance(el);
      setTable(0);
      dados.select(getTabName(0));
    }
  };

  const onSelectedTab = () => {
    const el = $('.tabs');
    let index = M.Tabs.getInstance(el).index;
    if (table !== index) {
      setTable(index);
    }
  };

  const onSelectedTabToProps = (index, refreshProps) => {
    if (index !== undefined && table !== index) {
      if (refreshProps) {
        setRefresh(refresh + 1);
      }
      setTable(index);
      const el = $('.tabs');
      const dados = M.Tabs.getInstance(el);
      dados.select(getTabName(index));
    }
  };

  return (
    <div className="">
      <div className="third-text-color">
        <div className="row" style={{ marginBottom: '-1px', marginTop: '10px' }}>
          <ul className="tabs">
            <li className={`tab col s3 ${props.volumeConfiguration?.packingId ? '' : 'disabled'}`}>
              <a className="active" href="#startVolume" onClick={onSelectedTab}>
                <i className="material-icons prefix">list</i>
              </a>
            </li>
            <li className={`tab col s3 ${props.volumeConfiguration?.registrationRequired ? '' : 'disabled'}`}>
              <a className="" href="#registrationVolume" onClick={onSelectedTab}>
                <i className="material-icons prefix">playlist_add</i>
              </a>
            </li>
            <li className={`tab col s3 ${props.volumeConfiguration?.packingId ? '' : 'disabled'}`}>
              <a className="" href="#confirmVolume" onClick={onSelectedTab}>
                <i className="material-icons prefix">playlist_add_check</i>
              </a>
            </li>
            <li className="tab col s3">
              <a className="" href="#volumeParameters" onClick={onSelectedTab}>
                <i className="material-icons">settings</i>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div id="startVolume" className="">
        <VolumeItem {...props} />
        <VolumeItemList {...props} />
      </div>
      <div id="registrationVolume" className="">
        <VolumeRegistrarion {...props} />
        <VolumeRegistrationList {...props} />
      </div>
      <div id="confirmVolume" className="">
        <ConfirmationVolume {...props} onSelectedTab={onSelectedTabToProps} setTable={setTable} />
      </div>
      <div id="volumeParameters" className="">
        <VolumeParameters onSelectedTab={onSelectedTabToProps}  {...props} />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    volumeConfiguration: state.volumeReducer.volumeConfiguration
  };
};

const mapDispatchToProps = () => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Volume));
